import { jsx as _jsx } from "react/jsx-runtime";
import { GrowthWorkspaceListPage } from './GrowthWorkspaceListPage';
/** GRW-02: `/growth/proposals` (proposal + pre_award workspaces, like `/projects`). */ export function ProposalsListPage() {
    return /*#__PURE__*/ _jsx(GrowthWorkspaceListPage, {
        kind: "proposal"
    });
}
